import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-ro",
  "use": "icon-flag-ro-usage",
  "viewBox": "0 0 1544 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1544 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-ro\"><defs><style type=\"text/css\"></style></defs><path d=\"M10.064 1017.71h1520.904V6.29H10.064v1011.42z m1524.678 3.774v-3.774 3.774zM3.774 1024V0h1533.484v1024H3.774z\" fill=\"#353636\" p-id=\"6192\" /><path d=\"M7.548 2.516h509.484v1017.71H7.548z\" fill=\"#004681\" p-id=\"6193\" /><path d=\"M515.774 2.516h509.484v1017.71H515.774z\" fill=\"#FCD200\" p-id=\"6194\" /><path d=\"M1025.258 2.516h509.484v1017.71h-509.484z\" fill=\"#CF3449\" p-id=\"6195\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-ro.svg
// module id = BP3n
// module chunks = 24